/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { InitialSavedState } from "./InitialSavedState";
import {
  InitialSavedStateFromJSON,
  InitialSavedStateFromJSONTyped,
  InitialSavedStateToJSON,
  InitialSavedStateToJSONTyped,
} from "./InitialSavedState";

/**
 *
 * @export
 * @interface PaginatedInitialSavedStateList
 */
export interface PaginatedInitialSavedStateList {
  /**
   *
   */
  count: number;
  /**
   *
   */
  next?: string | null;
  /**
   *
   */
  previous?: string | null;
  /**
   *
   */
  results: Array<InitialSavedState>;
}

/**
 * Check if a given object implements the PaginatedInitialSavedStateList interface.
 */
export function instanceOfPaginatedInitialSavedStateList(
  value: object
): value is PaginatedInitialSavedStateList {
  if (!("count" in value) || value["count"] === undefined) return false;
  if (!("results" in value) || value["results"] === undefined) return false;
  return true;
}

export function PaginatedInitialSavedStateListFromJSON(json: any): PaginatedInitialSavedStateList {
  return PaginatedInitialSavedStateListFromJSONTyped(json, false);
}

export function PaginatedInitialSavedStateListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PaginatedInitialSavedStateList {
  if (json == null) {
    return json;
  }
  return {
    count: json["count"],
    next: json["next"] === undefined ? undefined : json["next"] === null ? null : json["next"],
    previous:
      json["previous"] === undefined
        ? undefined
        : json["previous"] === null
        ? null
        : json["previous"],
    results: (json["results"] as Array<any>).map(InitialSavedStateFromJSON),
  };
}

export function PaginatedInitialSavedStateListToJSON(json: any): PaginatedInitialSavedStateList {
  return PaginatedInitialSavedStateListToJSONTyped(json, false);
}

export function PaginatedInitialSavedStateListToJSONTyped(
  value?: PaginatedInitialSavedStateList | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    count: value["count"],
    next: value["next"],
    previous: value["previous"],
    results: (value["results"] as Array<any>).map(InitialSavedStateToJSON),
  };
}
